<template>
  <egg-label-list
    title="workWithUs.whyChooseThe"
    titleColor="#603813"
    :starIconObj="{ componentName: 'shared', imgName: 'starIconDeepBlue', imgFormat: 'svg' }"
    :eggBackgroundObj="{ componentName: 'shared', imgName: 'deepgreenegg', imgFormat: 'svg' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg', position: 'right:0;' }"
    labelColor="#373F41"
    :eggIconLabelList="workWithUsStore.eggDescList"
    :isTextBold="false"
    class="pb-24"
  />
</template>

<script setup lang="ts">
import { useWorkWithUsStore } from "@/stores/workWithUs";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const workWithUsStore = useWorkWithUsStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>